//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Table from "@/components/FilterTable/Table.vue";

const DEFAULT_FORMAT = (value) => (value ? value : "N/A");

const TABLE_LIST_COLUMNS = [
  {
    name: "id",
    required: false,
    label: "#ID",
    align: "left",
    field: (row) => row.id,
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "level-number",
    required: false,
    align: "left",
    label: "Nº Nível",
    field: (row) => row.level_id,
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "classification-level",
    required: false,
    align: "left",
    label: "Classificação Nível",
    field: (row) => (row.level ? row.level.name : "N/A"),
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "designation-level",
    required: false,
    align: "left",
    label: "Designação Nível",
    field: (row) => row.name,
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "classification-level-agregator",
    required: false,
    align: "left",
    label: "Classificação Nível Agregador",
    field: (row) => (row.parent ? row.parent.level.name : "N/A"),
    format: DEFAULT_FORMAT,
    sortable: false,
  },
  {
    name: "designation-level-agregator",
    required: false,
    align: "left",
    label: "Designação Nível Agregador",
    field: (row) => (row.parent ? row.parent.name : "N/A"),
    format: DEFAULT_FORMAT,
    sortable: false,
  },
];

export default {
  name: "ProductTable",
  props: ["tableClass", "bordered", "data", "recordsTotal", "loading"],
  components: {
    Table,
  },
  mounted: function () {},
  data: () => ({
    separator: "horizontal",
    columns: TABLE_LIST_COLUMNS,
    filteredData: [],
  }),
  methods: {
    fetchRowData: function (index) {
      let data = this.data[index];
      this.$emit("clicked-row", data);
    },
    renderRightSide: function (event) {
      this.$emit("clicked-row", { ...event });
    },
    updateFilter: function (event) {
      this.$emit("filter-changed", event);
    },
  },
};
